import LogoWithWhiteFrameUrl from '@assets/logo-with-white-frame.png';
import { EventTypes } from '@racemap/sdk/schema/events';
import { DefaultLogoUrl } from '@racemap/utilities/consts/events';
import type { BrandPublicVersion } from '@racemap/utilities/types/brand';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import { Tag } from 'antd';
import type { Immutable } from 'immer';
import type { CurrentEvent } from '../store/events/events_reducers';

export function getSafemapUrl(event: Immutable<RacemapEvent | CurrentEvent>) {
  return `${window.location.origin}/safemap/${
    event.slug != null && event.slug !== '' ? event.slug : event.id
  }`;
}

export function getRacemapLogoUrl() {
  return DefaultLogoUrl;
}

export function getEventTypeDocuLink(eventType: EventTypes) {
  switch (eventType) {
    case EventTypes.REGULAR:
    case EventTypes.CONTEST:
    case EventTypes.STAGE:
      return 'live-tracking/basic-features-of-racemap-tracking-map';
    case EventTypes.CONTEST_GROUP:
    case EventTypes.STAGE_GROUP:
      return 'live-tracking/multi-event-map';
    case EventTypes.SAFEMAP:
      return 'live-tracking/safemap';
    default:
      throw new Error(`Unknown event type: ${eventType}`);
  }
}

export function getAppLogoUrl(brand?: BrandPublicVersion | null) {
  return brand == null
    ? LogoWithWhiteFrameUrl
    : `${window.location.origin}/api/brands/${brand.id}/asset?asset=appIconTransparent`;
}

export function getLogoUrl(event: Immutable<RacemapEvent | CurrentEvent>) {
  return event.images != null ? event.images.app : DefaultLogoUrl;
}

export function getDataFeedUrl(event: Immutable<RacemapEvent | CurrentEvent>) {
  return `${window.location.origin}/api/data/v1/${event.id}`;
}

export function getParentEditorUrl(event: Immutable<RacemapEvent | CurrentEvent>) {
  return `${window.location.origin}/admin/events/${event.parent}`;
}

export function getPreviewUrl(event: Immutable<RacemapEvent | CurrentEvent>) {
  const host =
    window.location.host === 'racemap.com' ? 'https://edge.racemap.com' : window.location.origin;
  return `${host}/api/events/${event.id}/preview`;
}

export function getTypeBadge(eventType: EventTypes) {
  switch (eventType) {
    case EventTypes.CONTEST:
      return (
        <Tag color="yellow" title="contest">
          C
        </Tag>
      );
    case EventTypes.CONTEST_GROUP:
      return (
        <Tag color="volcano" title="contest group">
          CG
        </Tag>
      );
    case EventTypes.REGULAR:
      return (
        <Tag color="green" title="regular">
          R
        </Tag>
      );
    case EventTypes.STAGE:
      return (
        <Tag color="blue" title="stage">
          S
        </Tag>
      );
    case EventTypes.STAGE_GROUP:
      return (
        <Tag color="purple" title="stage group">
          SG
        </Tag>
      );
    case EventTypes.SAFEMAP:
      return (
        <Tag color="magenta" title="safemap">
          SM
        </Tag>
      );
    default:
      return null;
  }
}
